// Sentry must init before anything else that might throw at import time.
import { initSentry, Sentry } from './observability/sentry'

initSentry()

import { QueryClient } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app'
import { PolygrafRoot } from './bootstrap'
import { ErrorFallback } from './components/error-fallback'
import './i18n' // Initialize i18n
import './styles/tailwind.css'
// Self-hosted faces for the transcript viewer's font options — regular and
// bold (the inverted / yellow-on-black presets force bold). All SIL OFL 1.1,
// see public/licenses/. Served from our origin, never a font CDN. Gelasio is
// the open, metric-compatible stand-in for Georgia. Each CSS covers every
// subset by unicode-range; the browser fetches only the ones a page uses.
import '@fontsource/opendyslexic/400.css'
import '@fontsource/opendyslexic/700.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/700.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/700.css'
import '@fontsource/gelasio/400.css'
import '@fontsource/gelasio/700.css'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 0,
			retry: 1,
		},
		mutations: {
			onError: (error) => {
				console.error('Mutation error', error)
			},
		},
	},
})

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<Sentry.ErrorBoundary
			fallback={(errorData) => (
				<ErrorFallback error={errorData.error} resetError={errorData.resetError} />
			)}
		>
			<PolygrafRoot router={{ kind: 'browser' }} queryClient={queryClient}>
				<App />
			</PolygrafRoot>
		</Sentry.ErrorBoundary>
	</React.StrictMode>,
)
